import http from '../../services/http-common';

class ProductInfoService {
    
    getProductInfoForList() {
    return http.get(`/ProductInfo/sp/list`);
    }
    insert(data) {
        return http.post(`/ProductInfo/db/add`,data);
    }
    update(data) {
        return http.put(`/ProductInfo/db/update`,data);
    }
}

export default new ProductInfoService();